import { usePageTitle } from 'utils/pageTitle';
import DashboardLayout from 'pages/_rd_dashboard/DashboardLayout';

import PortfolioMapWidget from 'pages/_rd_dashboard/PortfolioMapWidget';

import './PortfolioMap.css';


const PortfolioMap = (props) => {
	usePageTitle('Portfolio Map');

	return (
		<DashboardLayout>
			<div className="dashboard-portfolio-map">
				<div className="dashboard-section">
					<div className="dashboard-section-header">
						<h1><i className={'bi bi-geo-alt me-3'} />Portfolio Map</h1>
					</div>
					<div className="dashboard-section-body">
						<PortfolioMapWidget />
					</div>
				</div>
			</div>
		</DashboardLayout>
	);	


}

export default PortfolioMap;
